import { createAsyncThunk } from '@reduxjs/toolkit';

import { carAPI } from '@/modules/car/api';
import { Car } from '@/modules/car/model';
import { namespace } from '@/modules/car/namespace';
import { ThunkResult } from '@/shared/actions/thunk-result';

import { setAllCars } from '../actions';

let lastRequestId: string | undefined;

const loadAllCars = createAsyncThunk(
  `${namespace}/load-all-cars`,
  async (_, { dispatch, requestId }): Promise<ThunkResult<Car[]>> => {
    lastRequestId = requestId;

    const carsPage = await carAPI.fetchCars();

    if (lastRequestId !== requestId) {
      return { isReplaced: true };
    }

    dispatch(setAllCars(carsPage.items));

    return { result: carsPage.items };
  },
);

export { loadAllCars };
